import { Routes } from './components/Routes';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { AuthWrapper } from './containers/AuthWrapper';
import { PageLayout } from './components/layouts/PageLayout';
import { initUsageTracker } from './utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export const prepareApp = () => {
  initUsageTracker();
  const client = new DataFetchingClient();
  return {
    props: {
      dataFetchingClient: client
    }
  };
};
export function AppComponent({
  dataFetchingClient
}) {
  return /*#__PURE__*/_jsx(DataFetchingClientProvider, {
    client: dataFetchingClient,
    children: /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(AuthWrapper, {
        children: /*#__PURE__*/_jsx(PageLayout, {
          children: /*#__PURE__*/_jsx(Routes, {})
        })
      })
    })
  });
}